import { Record } from "immutable";
import { checkDate } from "common/helpers/Date";
import { DateStringNumber } from ".";

export const validationUploadStatsFromJSON = (
  json: Partial<IValidationUploadStatsData>,
): ValidationUploadStatsRecord => {
  const data: IValidationUploadStatsRecord = { ...(json as any) };

  if (json.latest_updated_at) {
    data.latest_updated_at = checkDate(json.latest_updated_at);
  }

  if (json.generated_at) {
    data.generated_at = checkDate(json.generated_at);
  }

  return new ValidationUploadStatsRecord(data);
};

export interface IValidationUploadStatsData {
  total_count: number;
  latest_updated_at: DateStringNumber;
  generated_at: DateStringNumber;
}

export interface IValidationUploadStatsRecord {
  total_count: number;
  latest_updated_at: Date;
  generated_at: Date;
}

const defaultValidationUploadStatsProps = {
  total_count: 0,
  latest_updated_at: new Date(),
  generated_at: new Date(),
};

export class ValidationUploadStatsRecord
  extends Record<IValidationUploadStatsRecord>(defaultValidationUploadStatsProps)
  implements IValidationUploadStatsRecord {}
